import React from 'react';
import PropTypes from 'prop-types';

import CollapsiblePanel from './CollapsiblePanelComponent';
import { keys } from 'lodash';
import {
  Col,
  Row,
  Table,
  Pagination,
  ButtonGroup,
  Button
} from 'react-bootstrap';
import { pageTypes } from './../helpers';
import ScenarioListItemContainer from '../Containers/ScenarioListItemContainer';
import RegressionFilterContainer from '../Containers/RegressionFilterContainer';

export default class ScenarioListComponent extends React.Component {
    static propTypes = {
      title: PropTypes.string.isRequired,
      order: PropTypes.number.isRequired,
      scenarios: PropTypes.array.isRequired,
      columns:PropTypes.arrayOf(PropTypes.object).isRequired,
      onCollapseAllClick: PropTypes.func.isRequired,
      onExpandAllClick: PropTypes.func.isRequired,
      onRetriggerAllClick: PropTypes.func.isRequired,
      onTogglePanel: PropTypes.func.isRequired,
      setActivePage: PropTypes.func.isRequired,
      activePage: PropTypes.number.isRequired,
      installerPage: PropTypes.bool.isRequired,
      panelsOpenStatus: PropTypes.object,
      concerningTrendingOnly: PropTypes.bool,
      setConcerningTrendingOnly: PropTypes.func.isRequired,
      currentDispatcherTestsOnly: PropTypes.bool,
      setCurrentDispatcherTestsOnly: PropTypes.func.isRequired,
      pageType: PropTypes.object.isRequired
    };


    render() {
      const {
        title,
        order,
        scenarios,
        columns,
        onExpandAllClick,
        onCollapseAllClick,
        onRetriggerAllClick,
        onTogglePanel,
        setActivePage,
        activePage,
        panelsOpenStatus,
        concerningTrendingOnly,
        setConcerningTrendingOnly,
        currentDispatcherTestsOnly,
        setCurrentDispatcherTestsOnly,
        installerPage,
        pageType
      } = this.props;

      const pageLimit = 10;
      if (!scenarios || !columns) {
        return null;
      }

      const count = keys(scenarios).length;

      if ((count === 0 && title !== 'Trending') ||
      (title === 'Trending' && installerPage)) {
        return null;
      }

      const scenariosLength = scenarios ? scenarios.length : 0;

      let start = 0;
      let end = this.props.scenarios.length;
      const activeFilteredPage = Math.floor(scenariosLength / pageLimit);

      if (pageLimit) {
        start = Math.min(activePage * pageLimit,
          activeFilteredPage * pageLimit);
        end = Math.min(scenariosLength, start + pageLimit);
      }

      const rows = [];

      for (let i = start; i < end; i++) {
        rows.push(
          <ScenarioListItemContainer
            key={i}
            index={i}
            columns={columns}
            order={order}
            scenario={scenarios[i]}
          />);
      }

      const showButtons = () => {
        if (title !== 'Trending' && title !== 'Trending Failed') {
          const retriggerAllButton = (title) => {
            if (title === 'Failed') {
              return (
                <Button onClick={() => onRetriggerAllClick()}>
                  Retrigger All
                </Button>
              );
            }
          };
          return (
            <ButtonGroup>
              <Button onClick={() => onExpandAllClick(order, scenariosLength)}>
                Expand All
              </Button>
              <Button onClick={() => onCollapseAllClick(order, scenariosLength)}>
                Collapse All
              </Button>
              {retriggerAllButton(title)}
            </ButtonGroup>
          );
        } else {
          return (
            <div>
              <Col mdOffset={8}>
                <label>
                  Show Concerning Only
                  <input
                    id="show-complement-checkbox"
                    type="checkbox"
                    checked={concerningTrendingOnly}
                    onChange={e => setConcerningTrendingOnly(e.target.checked)}
                    style={{ margin: '0 10px', verticalAlign: 'middle' }}
                  />
                </label>
                <label>
                  Show Current Dispatcher Tests Only
                  <input
                    id="show-complement-checkbox"
                    type="checkbox"
                    checked={currentDispatcherTestsOnly}
                    onChange={e => setCurrentDispatcherTestsOnly(e.target.checked)}
                    style={{ margin: '0 10px', verticalAlign: 'middle' }}
                  />
                </label>
              </Col>
              {pageType === pageTypes.ARTIFACTREGRESSION ? (<Col>
                <RegressionFilterContainer />
              </Col>) : null}
            </div>
          );
        }
      };

      const table = (
        <Table>
          <thead>
            <tr>
              <th key={-1}>{/*Space for the details chevron*/}</th>
              {
                columns.map((c, i) =>
                  <th key={i}>{c.hideHeader ? null : c.headerTitle}</th>
                )
              }
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      );

      let pageCount;
      if (!pageLimit) {
        pageCount = 1;
      } else {
        pageCount = Math.floor(this.props.scenarios.length / pageLimit);
        if (pageCount * pageLimit !== scenarios.length) {
          // If things don't fit exactly, add an extra page
          pageCount++;
        }
      }
      const items = [];
      const selectedPage = activePage + 1;
      items.push(
        <Pagination.Item key={1}
          active={1 === selectedPage ||
            (1 === pageCount && selectedPage > pageCount)}
          onClick={() => setActivePage(1)}
        >{1}</Pagination.Item>
      );
      if (selectedPage - 3 > 1)
        items.push(<Pagination.Ellipsis key="beginning-ellipses" />);

      for (let page = selectedPage - 2; page <= Math.max(selectedPage + 2, 5); page++)
      {
        if (page <= 1 || page > pageCount)
          continue;
        items.push(
          <Pagination.Item key={page}
            active={page === selectedPage ||
              (page === pageCount && selectedPage > pageCount)}
            onClick={() => setActivePage(page)}
          >{page}</Pagination.Item>
        );
      }

      if (selectedPage + 2 < pageCount && pageCount > 5)
      {
        if (selectedPage + 2 !== pageCount - 1)
          items.push(<Pagination.Ellipsis key="end-ellipses" />);
        items.push(
          <Pagination.Item key={pageCount}
            active={pageCount === selectedPage ||
              (pageCount === pageCount && selectedPage > pageCount)}
            onClick={() => setActivePage(pageCount)}
          >{pageCount}</Pagination.Item>
        );
      }
      const pagedTable = pageCount > 1 ?
        (
          <div>
            {table}
            <Pagination bsSize="small">
              <Pagination.First onClick={() => setActivePage(1)} />
              <Pagination.Prev onClick={() => setActivePage(selectedPage - 1)} />
              {items}
              <Pagination.Next onClick={() => setActivePage(
                (selectedPage + 1) >= pageCount ? pageCount : selectedPage + 1
              )}
              />
              <Pagination.Last onClick={() => setActivePage(pageCount)} />
            </Pagination>
          </div>
        ) :
        table;
      const openStatus = panelsOpenStatus ? panelsOpenStatus[title] : false;
      return (
        <CollapsiblePanel
          onToggle={() => onTogglePanel(title)}
          expanded={openStatus}
          title={title + ' (' + count + ')'}
        >
          <Row>
            {showButtons()}
            {pagedTable}
          </Row>
        </CollapsiblePanel>
      );
    }
}


// WEBPACK FOOTER //
// src/Components/ScenarioListComponent.jsx